// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1C84g","footer":"ModalInfo_footer__1jPJL"};